import { makeStyles } from '@material-ui/core';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import React, { useEffect, useState } from 'react';
import { dataService } from '../../services/data/data.service';
import WasteStreamsPerMonth from './charts/wasteStreamPerMonth';
import WasteStreams from './charts/wasteStreams';
import WasteStreamDonuts from './charts/wasteStreamDonuts';
import WastePivotGrid from './charts/wastePivotGrid';
import Grid from '@mui/material/Grid';
import { FadingBalls } from 'react-cssfx-loading/lib';
import { MenuProps } from "../../reducers/Charts/charts";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";

import * as nlMessages from "devextreme/localization/messages/nl.json";


import { locale, loadMessages } from "devextreme/localization";

export default function ReportsPage(props) {
    const classes = useStyles();
    const [pivotData, setPivotData] = useState([]);
    const [chartData, setchartData] = useState([]);
    const [chartWasteData, setchartwasteData] = useState([]);
    const [pieData, setPieData] = useState([]);
    const [wastestreams, setWastestreams] = useState([]);
    const [wastestreamObject, setWasteStreamObject] = useState([]);
    const [chartWastestreams, setChartWastestream] = useState([]);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [dataLoad, setDataLoad] = useState(false);
    const [years, setYears] = useState([]);
    const [selectedWasteStreamFilter, setWasteStreamFilter] = useState(null);
    const [dataByYear, setDataByYear] = useState(null);
    const [foreignObjects, setForeignObject] = useState({});
    const [filterLevel, setFilterLevel] = useState(0);
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [isFirstLevel, setFirstLevel] = useState(true);
    const [isLoading, setLoading] = useState(true);
    const [selectedCities, setSelectedCities] = useState([]);
    const [allCities, setCities] = useState([]);
    // if(allCities.length > 0){
    const isAllSelected = allCities.length > 0 && selectedCities.length === allCities.length;
    // }

    useEffect(() => {
        initMessages();
        setLocale("nl-BE");
        sessionStorage.setItem("locale", "nl-BE");

        loadMessages(nlMessages);
        locale("nl-BE");

        let year = new Date().getFullYear();
        let tempyears = [];

        for (let i = year - 25; i < year + 25; i++) {
            tempyears.push(i);
        }
        getMaterials();
        getWastestreams();
        setYears(tempyears);
        getReportdataByYear(year);


    }, []);

    const getMaterials = () => {
        let foreign = {};
        dataService.GetMaterials().then(
            materialResult => {
                if (materialResult) {
                    if (materialResult.ok) {

                        setForeignObject(materialResult.data);
                    } else {
                        console.log("material result not ok");
                    }
                }
            },
            error => {
                console.log("failed fetching registrations");
            }
        );
    }
    const getWastestreams = () => {
        let foreign = {};
        dataService.GetWastestreams().then(
            wastestreamResult => {
                if (wastestreamResult) {
                    if (wastestreamResult.ok) {
                        setWasteStreamObject(wastestreamResult.data);
                        // foreign.materialId = wastestreamResult.data.sort((a, b) => a.materialDescription.localeCompare(b.materialDescription));
                        // foreign.materialId.forEach(x => {
                        //     x.materialDescription = x.materialDescription.charAt(0).toUpperCase() + x.materialDescription.slice(1);
                        // })
                        // setForeignObject(foreign);
                    } else {
                        console.log("material result not ok");
                    }
                }
            },
            error => {
                console.log("failed fetching registrations");
            }
        );
    }

    const initMessages = () => {
        loadMessages(nlMessages);
    }
    const setLocale = (savingLocale) => {
        sessionStorage.setItem("locale", savingLocale);
    }

    const getReportdataByYear = (year) => {
        setLoading(true);
        setDataLoad(false);
        dataService.getAllRegistrations()
            .then(
                registrationsResult => {
                    if (registrationsResult) {
                        if (registrationsResult.ok) {
                            let getCities = registrationsResult.data.reduce((r, a) => {
                                r[a.originName] = [...r[a.originName] || [], a];
                                return r;
                            }, {});
                            var cities = Object.keys(getCities);

                            var chartDataByYear = registrationsResult.data.filter(r => r.periodValue.includes(year));

                            var groupedByWastestream = []
                            groupedByWastestream = chartDataByYear.reduce((r, a) => {
                                r[a.wasteStreamDescription] = [...r[a.wasteStreamDescription] || [], a];
                                return r;
                            }, {});
                            var thisWastestreams = Object.keys(groupedByWastestream).sort(function (a, b) {
                                return a.localeCompare(b); //using String.prototype.localCompare()
                            });

                            setCities(cities);
                            setSelectedCities(cities);
                            setDataByYear(chartDataByYear);
                            setChartWastestream(thisWastestreams);
                            setWastestreams(thisWastestreams);
                            configurePieData(chartDataByYear, thisWastestreams, null, filterLevel);
                            configurePivotData(registrationsResult.data);
                            configureChartData(chartDataByYear, thisWastestreams, null, filterLevel);
                            configureWasteCityData(chartDataByYear, thisWastestreams, cities);
                            setDataLoad(true);
                        } else {
                            console.log("registrations result not ok");
                        }
                    }
                },
                error => {
                    console.log("failed fetching registrations");
                }
            );

    }

    const getReportdataByCityAndYear = (tempCities, year) => {
        let diffCities = allCities.filter(x => selectedCities.includes(x));
        let missinigCities = [];
        for (var i = 0; i < allCities.length; i++) {
            if (tempCities.includes(allCities[i])) {
            } else {
                missinigCities.push(allCities[i]);
            }
        }
        setLoading(true);
        setDataLoad(false);
        dataService.getAllRegistrations()
            .then(
                registrationsResult => {
                    if (registrationsResult) {
                        if (registrationsResult.ok) {
                            var bycity = registrationsResult.data.filter(r => tempCities.includes(r.originName));
                            var chartDataByYear = bycity.filter(r => r.periodValue.includes(year));
                            var groupedByCity = [];
                            groupedByCity = chartDataByYear.reduce((r, a) => {
                                // if(tempCities.includes(a.originName)){
                                r[a.originName] = [...r[a.originName] || [], a];
                                return r;
                                // }

                            }, {});

                            var groupedByWastestream = [];
                            groupedByWastestream = chartDataByYear.reduce((r, a) => {
                                r[a.wasteStreamDescription] = [...r[a.wasteStreamDescription] || [], a];
                                return r;
                            }, {});
                            var cities = Object.keys(groupedByCity);
                            var thisWastestreams = Object.keys(groupedByWastestream).sort(function (a, b) {
                                return a.localeCompare(b); //using String.prototype.localCompare()
                            });
                            //setCities(cities);
                            //setSelected(cities);
                            setDataByYear(chartDataByYear);
                            setChartWastestream(thisWastestreams);
                            // //setWastestreams(thisWastestreams);
                            configurePieData(chartDataByYear, thisWastestreams, selectedFilter, filterLevel, tempCities);
                            configurePivotData(registrationsResult.data);
                            configureChartData(chartDataByYear, thisWastestreams, selectedFilter, filterLevel, tempCities);
                            configureWasteCityData(chartDataByYear, thisWastestreams, tempCities);
                            setDataLoad(true);
                        } else {
                            console.log("registrations result not ok");
                        }
                    }
                },
                error => {
                    console.log("failed fetching registrations");
                }
            );
    }
    const handleDateChange = (event) => {
        setFirstLevel(true);
        setSelectedYear(event.target.value);
        getReportdataByCityAndYear(selectedCities, event.target.value);
    };
    const handleSelectCity = (event) => {
        const value = event.target.value;
        if (value[value.length - 1] === "all") {
            setSelectedCities(selectedCities.length === allCities.length ? [] : allCities);
            if (selectedCities.length !== allCities.length) {
                getReportdataByCityAndYear(allCities, selectedYear);
            }
            return;
        }
        getReportdataByCityAndYear(event.target.value, selectedYear);
        setSelectedCities(value);
    };

    /* Pie chart */
    const configurePieData = (data, thisWastestreams, wasteStreamFilter, chartFilterLevel, tempCities) => {
        let tempchartData = [];
        var i = 0;
        let dataToUse = [];
        dataToUse = data;
        let wastestreamId = null;
        let materialId = null;
        if (chartFilterLevel === 0) {
            for (i = 0; i < thisWastestreams.length; i++) {
                tempchartData[i] = {};
                var wasteStream = (thisWastestreams[i]);
                tempchartData[i]['material'] = wasteStream;
                tempchartData[i]['quantity'] = 0;
            }

        } else {
            if (chartFilterLevel === 1) {
                let tempDataToUse = dataToUse;
                let selectedWastestream = wastestreamObject.find(x => x.wastestreamDescription === wasteStreamFilter);
                if (selectedWastestream === undefined) {
                    let tempobj = foreignObjects.find(x => x.materialDescription === wasteStreamFilter);
                    selectedWastestream = wastestreamObject.find(x => x.id === tempobj.wastestreamId);
                }
                wastestreamId = selectedWastestream.id;
                dataToUse = tempDataToUse;
                let materials = foreignObjects.filter(x => x.wastestreamId === selectedWastestream.id);
                for (i = 0; i < materials.length; i++) {
                    tempchartData[i] = {};
                    var wasteStream = (materials[i].materialDescription);
                    tempchartData[i]['material'] = wasteStream;
                    tempchartData[i]['quantity'] = 0;
                }

            } else {
                let tempDataToUse = dataToUse;
                let selectedWastestream = wastestreamObject.find(x => x.materialDescription === wasteStreamFilter);
                if (selectedWastestream === undefined) {
                    let tempobj = foreignObjects.find(x => x.materialDescription === wasteStreamFilter);
                    selectedWastestream = wastestreamObject.find(x => x.id === tempobj.wastestreamId);
                    materialId = tempobj.id;

                }
                wastestreamId = selectedWastestream.id;

                dataToUse = tempDataToUse;
                let materials = foreignObjects.filter(x => x.wastestreamId === selectedWastestream.id);
                for (i = 0; i < materials.length; i++) {
                    tempchartData[i] = {};
                    var wasteStream = (materials[i].materialDescription);
                    tempchartData[i]['material'] = wasteStream;
                    tempchartData[i]['quantity'] = 0;
                }

            }

        }

        if (wastestreamId !== null) {
            if (chartFilterLevel === 1) {
                dataToUse = dataToUse.filter(x => x.wasteStreamId === wastestreamId);
            } else {
                dataToUse = dataToUse.filter(x => x.materialId === materialId);

            }
        }

        dataToUse.map(record => {
            let quantity = 0;
            var wasteStream = record.wasteStreamDescription;
            var material = record.materialDescription;
            var city = record.originName;

            let thisRecord = {};
            if (chartFilterLevel !== 0) {

                wasteStream = record.materialDescription;
                if (tempchartData.some(x => x.material === wasteStream)) {
                    tempchartData.find(x => x.material === wasteStream)['quantity'] += parseFloat(record.quantity);
                } else {
                    thisRecord['material'] = wasteStream;
                    thisRecord['quantity'] = parseFloat(record.quantity);
                    tempchartData.push(thisRecord);
                }



            } else {
                if (tempchartData.some(x => x.material === wasteStream)) {
                    quantity = parseFloat(record.quantity);
                    tempchartData.find(x => x.material === wasteStream)['quantity'] += quantity;
                } else {
                    quantity = parseFloat(record.quantity);
                    tempchartData[wasteStream]['quantity'] += quantity;
                }
            }
        });
        setPieData(tempchartData);
    }

    /* Waste per month */
    const configureChartData = (data, thisWastestreams, wasteStreamFilter, chartFilterLevel, tempCities) => {
        setLoading(true);
        let tempchartData = [];
        var months = 12;
        var newmaterials = [];
        var tempData = [];
        tempData = data;
        let tempMaterialArr = {};
        let wastestreamId = null;
        let materialId = null;
        if (wasteStreamFilter !== null) {
            if (chartFilterLevel === 1) {

                let selectedWastestream = wastestreamObject.find(x => x.wastestreamDescription === wasteStreamFilter);
                if (selectedWastestream === undefined) {
                    let tempobj = foreignObjects.find(x => x.materialDescription === wasteStreamFilter);
                    selectedWastestream = wastestreamObject.find(x => x.id === tempobj.wastestreamId);
                }

                wastestreamId = selectedWastestream.id;

                let materials = foreignObjects.filter(x => x.wastestreamId === selectedWastestream.id);
                for (i = 0; i < materials.length; i++) {
                    var firstwastestream = materials[i].materialDescription;

                    tempMaterialArr[firstwastestream] = 0;
                    if (!(newmaterials.indexOf(firstwastestream) > -1)) {
                        newmaterials.push(firstwastestream);
                    }
                }
            } else {
                let selectedWastestream = wastestreamObject.find(x => x.materialDescription === wasteStreamFilter);
                if (selectedWastestream === undefined) {
                    let tempobj = foreignObjects.find(x => x.materialDescription === wasteStreamFilter);
                    materialId = tempobj.id;
                    selectedWastestream = wastestreamObject.find(x => x.id === tempobj.wastestreamId);
                }
                wastestreamId = selectedWastestream.id;

                let materials = foreignObjects.filter(x => x.wastestreamId === selectedWastestream.id);
                for (i = 0; i < materials.length; i++) {
                    var firstwastestream = materials[i].materialDescription;

                    tempMaterialArr[firstwastestream] = 0;
                    if (!(newmaterials.indexOf(firstwastestream) > -1)) {
                        newmaterials.push(firstwastestream);
                    }
                }
            }


        }

        //SC: First loop through the months so we always have them in the correct order.
        for (var i = 0; i < months; i++) {
            var chartDataObject = { month: getMonthName(i) };
            if (wasteStreamFilter === null) {
                for (var x = 0; x < thisWastestreams.length; x++) {
                    var firstwastestream = thisWastestreams[x];
                    chartDataObject[firstwastestream] = 0;
                    if (!(newmaterials.indexOf(firstwastestream) > -1)) {
                        newmaterials.push(firstwastestream);
                    }
                }
            } else {
                chartDataObject = { ...chartDataObject, ...tempMaterialArr };


                // for (i = 0; i < materials.length; i++) {

                // //var firstwastestream = materials[i];
                // console.log(firstwastestream)
                // //     chartDataObject[firstwastestream] = 0;
                // //     if (!(newmaterials.indexOf(firstwastestream) > -1)) {
                // //         newmaterials.push(firstwastestream);
                // //     }
                // }
            }

            tempchartData.push(chartDataObject);
        }
        if (wastestreamId !== null) {
            if (chartFilterLevel === 1) {
                tempData = tempData.filter(x => x.wasteStreamId === wastestreamId);
            } else {
                tempData = tempData.filter(x => x.materialId === materialId);

            }
        }

        //SC: Build the data
        tempData.map(record => {
            if (chartFilterLevel > 0) {
                var wastestream = record.materialDescription;
            } else {
                var wastestream = record.wasteStreamDescription;
            }

            let quantity = 0;
            if (tempchartData.some(x => x.month === getMonthName(new Date(record.periodValue).getMonth()))) {
                quantity = parseFloat(record.quantity);
                if (chartFilterLevel > 0) {
                    if (tempchartData.find(x => x.month === getMonthName(new Date(record.periodValue).getMonth()))[wastestream] !== undefined) {
                        tempchartData.find(x => x.month === getMonthName(new Date(record.periodValue).getMonth()))[wastestream] += quantity;
                    } else {
                        var temp = {};
                        temp[wastestream] = quantity;
                        if (!(newmaterials.includes(wastestream))) {
                            newmaterials.push(wastestream);
                        }
                        tempchartData.find(x => x.month === getMonthName(new Date(record.periodValue).getMonth()))[wastestream] = quantity;
                    }
                } else {
                    tempchartData.find(x => x.month === getMonthName(new Date(record.periodValue).getMonth()))[wastestream] += quantity;

                }

            } else {
                var chartDataObject = { month: getMonthName(new Date(record.periodValue).getMonth()) };
                var i;
                if (chartFilterLevel > 0) {
                    chartDataObject[wastestream] = 0;

                } else {
                    for (i = 0; i < thisWastestreams.length; i++) {

                        var waste = thisWastestreams[i];
                        chartDataObject[waste] = 0;
                    }
                }


                quantity = parseFloat(record.quantity);
                chartDataObject[wastestream] = Math.round(quantity);
                tempchartData.push(chartDataObject);
            }
        });
        setLoading(false);
        setChartWastestream(newmaterials);
        setchartData(tempchartData);
    };

    /* DONUT CHARTS */
    const configureWasteCityData = (data, thisWastestreams, cities) => {
        let chartData = [];
        var numrows = thisWastestreams.length;
        let usecities = cities.sort();

        let alphabeticalWastestreams = thisWastestreams.sort();
        for (var i = 0; i < numrows; i++) {
            var material = alphabeticalWastestreams[i];
            var chartDataObject = { wasteStreamDescription: material, pieData: [] };
            for (var x = 0; x < usecities.length; x++) {
                chartDataObject.pieData.push({ city: usecities[x], val: 0 });
            }
            chartData.push(chartDataObject);
        }
        data.map(record => {
            var numberQuantity = Number((Math.round(record.quantity * 100) / 100).toFixed(2));
            var materialTrans = record.wasteStreamDescription;
            if (chartData.some(x => x.wasteStreamDescription === materialTrans)) {

                if (chartData.find(x => x.wasteStreamDescription === materialTrans).pieData.some(y => y.city === record.originName)) {
                    chartData.find(x => x.wasteStreamDescription === materialTrans).pieData.find(y => y.city === record.originName).val += numberQuantity;
                }
                else {
                    chartData.find(x => x.wasteStreamDescription === materialTrans).pieData.push({ city: record.originName, val: numberQuantity })
                }
            } else {
                var chartDataObject = { wasteStreamDescription: materialTrans, pieData: [] };
                chartDataObject.pieData.push({ city: record.originName, val: numberQuantity })
                chartData.push(chartDataObject);
            }
        });
        setchartwasteData(chartData);
    }
    const onPointClick = (e) => {
        if (e.target.data.quantity > 0) {
            let tempData = dataByYear;
            let tempFirstLevel = filterLevel;
            tempFirstLevel = tempFirstLevel + 1;
            if (tempFirstLevel <= 2) {
                setSelectedFilter(e.target.data.material);

            }
            var clicked = e.target.data.material;

            let dataToUse = [];
            if (tempFirstLevel === 1) {
                //We'll have to filter on per wastestream
                dataToUse = tempData.filter(x => x.wasteStreamDescription === clicked);
                setWasteStreamFilter(clicked);
                setFirstLevel(false);
                setFilterLevel(tempFirstLevel);
                configureChartData(dataToUse, wastestreams, clicked, tempFirstLevel);
                configurePieData(dataToUse, wastestreams, clicked, tempFirstLevel);
            } else if (tempFirstLevel === 2) {
                //We'll have to filter on per material
                dataToUse = tempData.filter(x => x.materialDescription === (clicked));
                configurePieData(dataToUse, wastestreams, clicked, tempFirstLevel);
                configureChartData(dataToUse, wastestreams, clicked, tempFirstLevel);

                setFilterLevel(tempFirstLevel);

            } else {
                //putty lowest level
            }
        }else{

        }
    }

    const onButtonClick = () => {
        //setFirstLevel(true);
        let tempData = dataByYear;
        let dataToUse = [];

        let tempFilterLevel = filterLevel - 1;
        if (tempFilterLevel === 1) {
            let tempfilter = dataByYear.find(x => (x.materialDescription) === selectedFilter).wasteStreamDescription;
            dataToUse = tempData.filter(x => x.wasteStreamDescription === tempfilter);
            configurePieData(dataToUse, wastestreams, tempfilter, tempFilterLevel);
            configureChartData(dataToUse, wastestreams, tempfilter, tempFilterLevel);
            setFilterLevel(tempFilterLevel);
            setSelectedFilter(tempfilter);

        } else if (tempFilterLevel === 0) {
            configurePieData(dataByYear, wastestreams, null, tempFilterLevel);
            configureChartData(dataByYear, wastestreams, null, tempFilterLevel);
            setFilterLevel(tempFilterLevel);
            setSelectedFilter(null);

        }



    }

    /* PIVOT GRID */
    const configurePivotData = (data) => {
        var newPivotData = []
        var i;
        for (i = 0; i < data.length; i++) {
            var wastestream = (data[i].wasteStreamDescription);
            var material = (data[i].materialDescription);

            if (newPivotData.some(x => x.date === new Date(data[i].periodValue) && x.originName === data[i].originName && x.wastestream === wastestream)) {
                newPivotData.find(x => x.date === new Date(data[i].periodValue) && x.originName === data[i].originName && x.wastestream === wastestream).quantity += parseFloat(data[i].quantity.toFixed(2));
            }
            else {
                newPivotData.push({ id: data[i].id, quantity: parseFloat(data[i].quantity.toFixed(2)), date: new Date(data[i].periodValue), originName: data[i].originName, wastestream: wastestream, material: material })
            }
        }

        setPivotData(newPivotData)
    }

    const getMonthName = (monthNumber) => {
        switch (monthNumber) {
            case 0:
                return "Januari"
            case 1:
                return "Februari"
            case 2:
                return "Maart"
            case 3:
                return "April"
            case 4:
                return "Mei"
            case 5:
                return "Juni"
            case 6:
                return "Juli"
            case 7:
                return "Augustus"
            case 8:
                return "September"
            case 9:
                return "Oktober"
            case 10:
                return "November"
            case 11:
                return "December"
        }
    }

    const theme = createTheme({
        components: {
            MuiSelect: {
                styleOverrides: {
                    root: {
                        backgroundColor: 'white',
                        border: 'none',
                        outline: 'none',
                        MuiOutlinedInput: {
                            border: 'none',
                            outline: 'none'
                        }
                    },
                },
            },
        },
    });


    return (
        <div className={classes.container}>
            {(chartWasteData.length > 0 || dataLoad) ?
                <div>
                    <div className={classes.filterContainer}>
                        <div className={classes.yearFilter}>
                            <div className={classes.textTitle}>{"Jaar"}</div>
                            <ThemeProvider theme={theme}>

                                <FormControl sx={{ minWidth: 120 }} className={classes.formControlFilter}>
                                    <Select
                                        id="select"
                                        label={"Jaar"}

                                        value={selectedYear}
                                        onChange={handleDateChange}
                                        MenuProps={{ style: { maxHeight: 400, disableScrollLock: true, } }}
                                        className={classes.yearDropdown}

                                    >
                                        {
                                            years.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)
                                        }
                                    </Select>
                                </FormControl>
                            </ThemeProvider>

                        </div>
                        <div className={classes.cityFilter}>
                            <ThemeProvider theme={theme}>

                                <FormControl className={classes.formControl}>
                                    <div className={classes.textTitle}>{"Steden"}</div>

                                    <Select
                                        multiple
                                        value={selectedCities}
                                        onChange={handleSelectCity}
                                        renderValue={(selectedCities) => selectedCities.join(", ")}
                                        MenuProps={MenuProps}
                                        className={classes.cityDropdown}

                                    >
                                        <MenuItem
                                            value="all"
                                            classes={{
                                                root: isAllSelected ? classes.selectedAll : ""
                                            }}
                                        >
                                            <ListItemIcon>
                                                <Checkbox
                                                    classes={{ indeterminate: classes.indeterminateColor }}
                                                    checked={isAllSelected}
                                                    style={{ color: '#1F8FA5' }}
                                                    indeterminate={
                                                        selectedCities.length > 0 && selectedCities.length < allCities.length
                                                    }
                                                />
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.selectAllText }}
                                                primary="Alle steden"
                                            />
                                        </MenuItem>
                                        {allCities.map((option) => (
                                            <MenuItem key={option} value={option}>
                                                <ListItemIcon>
                                                    <Checkbox checked={selectedCities.indexOf(option) > -1} style={{ color: '#1F8FA5' }} />
                                                </ListItemIcon>
                                                <ListItemText primary={option} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </ThemeProvider>

                        </div>
                    </div>
                    <Grid container className={classes.chartContainer} spacing={2}>
                        <Grid item className={classes.donutChartGrid} xs={12} md={4} lg={4}>
                            <WasteStreams rows={pieData} onPointClick={onPointClick} isFirstLevel={isFirstLevel} filterLevel={filterLevel} onButtonClick={onButtonClick} isLoading={isLoading} filter={selectedFilter}></WasteStreams>
                        </Grid>

                        <Grid item className={classes.donutChartGrid} xs={12} md={8} lg={8}>
                            <WasteStreamsPerMonth rows={chartData} wastestreams={wastestreams} chartWastestreams={chartWastestreams} onPointClick={onPointClick} isFirstLevel={isFirstLevel} filterLevel={filterLevel} onButtonClick={onButtonClick} isLoading={isLoading} filter={selectedFilter}></WasteStreamsPerMonth>
                        </Grid>
                    </Grid>

                    <WasteStreamDonuts data={chartWasteData} isLoading={isLoading}></WasteStreamDonuts>
                    <WastePivotGrid data={pivotData}></WastePivotGrid>
                </div>
                :
                <div className={classes.loadingContainer}>
                    <div className={classes.loadingCharts}>{"Grafieken laden"}</div>
                    <FadingBalls color="#1F8FA5" width="15px" height="15px"></FadingBalls>
                </div>
            }



        </div>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        paddingTop: "25px",
        paddingLeft: "50px",
        paddingRight: "50px",
        paddingBottom: "50px",


        flexWrap: 'wrap',
    },
    chartContainer: {
        marginTop: '15px',
        width: '100%',
        display: 'flex',
    },
    loadingContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100vw",
        paddingTop: "10vw"
    },
    loadingNewData: {
        position: 'absolute',
    },
    loadingCharts: {
        marginBottom: '20px',
        fontSize: "18px",
        fontWeight: "bold",
        fontFamily: "Lato, sans-serif",
        color: "#1F8FA5",
    },
    chartContainer: {
        alignItems: 'start',
        width: '150px',
        justifyContent: 'start',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '16px'
    },
    whitePlane: {
        backgroundColor: 'white',
        padding: '15px',
        marginBottom: '25px'
    },
    yearDropdown: {
        fontSize: '20pt',
        fontFamily: "Segoe UI Light",
        "& .MuiOutlinedInput-notchedOutline": {
            border: 'none',
            outline: 'none'
        },

    },
    cityDropdown: {
        fontSize: '20pt',
        fontFamily: "Segoe UI Light",
        "& .MuiOutlinedInput-notchedOutline": {
            border: 'none',
            outline: 'none'
        },
    },
    textTitle: {
        fontSize: '16px',
        fontFamily: 'Lato, sans-serif',
        color: '#616A6E',
    },
    formControlFilter: {
        textAlign: 'start',
        border: '0px',
        outline: '0px',
    },
    filterContainer: {
        marginBottom: '15px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',

    },
    yearFilter: {
        marginRight: '30px',
    },
    formControl: {
        width: 300
    },
    indeterminateColor: {
        color: "#f50057"
    },
    selectAllText: {
        fontWeight: 500
    },
    selectedAll: {
        backgroundColor: "rgba(0, 0, 0, 0.08)",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.08)"
        }
    },
    donutChartGrid: {
        height: '50%'
    }
}));